import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, RefreshCw, RotateCw, CheckCircle, HelpCircle } from 'lucide-react';
import { createRoot } from 'react-dom/client';

// Die Daten aus der Analyse, integriert als Konstante
const questionsData = [
  {
    "Nummer": 223,
    "Frage": "Welche der Aussagen zum Umgang mit medizinischem Sauerstoff ist korrekt?",
    "Optionen": [
      "Sauerstoff darf nicht in unmittelbarer Nähe einer offenen Flamme benutzt werden und darf nicht mit Öl oder Fett in Berührung kommen.",
      "Sauerstoffflaschen sollten möglichst immer stehend transportiert werden, damit kein zusätzlicher Druck auf das Ventil kommt.",
      "Bei Undichtigkeiten am Ventil ist eine Sauerstoffgabe bis zu 2l/min unbedenklich.",
      "Sauerstoffflaschen müssen immer vollständig entleert werden, bevor sie transportiert werden dürfen.",
      "Medizinischer Sauerstoff ist unbegrenzt haltbar."
    ],
    "Antworten": [
      "Sauerstoff darf nicht in unmittelbarer Nähe einer offenen Flamme benutzt werden und darf nicht mit Öl oder Fett in Berührung kommen."
    ]
  },
  {
    "Nummer": 68,
    "Frage": "Wie ist der Begriff \"Notfall\" im medizinischen Sinn definiert?",
    "Optionen": [
      "Lebenswichtige Organe müssen bereits gestört sein.",
      "Es liegt immer eine akute Erkrankung vor.",
      "Lebenswichtige Funktionen sind gestört, oder ihre Störung ist zu erwarten.",
      "Der Patient befindet sich in einer Gefahrensituation."
    ],
    "Antworten": [
      "Lebenswichtige Funktionen sind gestört, oder ihre Störung ist zu erwarten."
    ]
  },
  {
    "Nummer": 66,
    "Frage": "Welches Erkennungsmerkmal ist typisch für eine Hyperventilation?",
    "Optionen": [
      "Lange tiefe Atemzüge mit langer Pause zwischen den Atemzügen.",
      "Krämpfe im Brust- und Bauchbereich",
      "Der Patient lässt sich leicht beruhigen.",
      "Empfindungsstörungen an Händen, Füßen und Gesichtshaut"
    ],
    "Antworten": [
      "Empfindungsstörungen an Händen, Füßen und Gesichtshaut"
    ]
  },
  {
    "Nummer": 56,
    "Frage": "Die Atemsteuerung erfolgt hauptsächlich durch Messung des ...-Spiegels im Blut",
    "Optionen": [
      "Stickstoff",
      "Kohlendioxid",
      "Sauerstoff",
      "Kohlenmonoxid"
    ],
    "Antworten": [
      "Kohlendioxid"
    ]
  },
  {
    "Nummer": 79,
    "Frage": "Welche Materialien werden nach Gebrauch nicht(!) gereinigt bzw. desinfiziert?",
    "Optionen": [
      "Krankentrage",
      "benutzte Spritzen, Infusionssysteme und Kanülen",
      "Behandlungsliege und Wäsche",
      "Stethoskop und Blutdruckmanschette"
    ],
    "Antworten": [
      "benutzte Spritzen, Infusionssysteme und Kanülen"
    ]
  },
  {
    "Nummer": 238,
    "Frage": "Bei einem Zeckenbiss können Krankheiten übertragen werden. Welche der Aussagen ist korrekt?",
    "Optionen": [
      "Die Zecke sollte schnellstmöglich entfernt werden, da das Infektionsrisiko umso geringer ist, je kürzer die Zecke Blut saugen konnte.",
      "Gegen die von Zecken übertragenen Krankheiten gibt es keinerlei Impfmöglichkeit.",
      "Zur Entfernung eignen sich besonders Utensilien wie Öl und Klebstoff.",
      "Ein Arztbesuch ist nach der Entfernung nicht nötig. Wenn die Zecke entfernt wurde, bevor sie mit dem Saugakt fertig war, liegt sicher keine Infektion vor.",
      "Zecken sind bekannt für ihre guten Sprung- und Flugfähigkeiten. Üblicherweise springen sie von Bäumen oder Büschen bis zu 2m auf den Patienten."
    ],
    "Antworten": [
      "Die Zecke sollte schnellstmöglich entfernt werden, da das Infektionsrisiko umso geringer ist, je kürzer die Zecke Blut saugen konnte.",
      "Zecken sind bekannt für ihre guten Sprung- und Flugfähigkeiten. Üblicherweise springen sie von Bäumen oder Büschen bis zu 2m auf den Patienten."
    ]
  },
  {
    "Nummer": 95,
    "Frage": "Eine Sauerstoffflasche mit 2 Liter Inhalt und einem Druck von 200 bar soll bei einem Fluss von 4l/min Sauerstoff liefern, bis zu einem Restdruck von 10 bar. Wie lange reicht der Vorrat etwa?",
    "Optionen": [
      "55 Minuten",
      "35 Minuten",
      "95 Minuten",
      "75 Minuten",
      "115 Minuten"
    ],
    "Antworten": [
      "95 Minuten"
    ]
  },
  {
    "Nummer": 225,
    "Frage": "Nenne drei Erkennungsmerkmale für das stille Ertrinken.",
    "Optionen": null,
    "Antworten": [
      "Die Augen sind glasig und leer.",
      "Der Ertrinkende beschleunigt die Atmung und kämpft nach Luft.",
      "Es wird versucht, sich auf den Rücken zu drehen."
    ]
  },
  {
    "Nummer": 129,
    "Frage": "Nenne mindestens drei Wundarten, die im Kurs behandelt wurden bzw. in der Teilnehmerunterlage genannt sind.",
    "Optionen": null,
    "Antworten": [
      "Stichwunde",
      "Platzwunde",
      "Schusswunde"
    ]
  },
  {
    "Nummer": 81,
    "Frage": "Wenn der AED eine Fehlfunktion anzeigt...",
    "Optionen": [
      "wird trotzdem nach den Anweisungen des Gerätes verfahren.",
      "sollte die Durchführung der HLW nach Möglichkeit an Passanten übergeben werden, um sich auf eine Fehlersuche zu begeben. Ggf. holt der Sanitätshelfer der DLRG einen zweiten AED, sofern er dafür den Einsatzort nicht länger als drei Minuten verlassen muss.",
      "wird die HLW unverzüglich ohne den AED fortgeführt.",
      "führt ein Helfer die Basismaßnahmen weiter, während der Zweite Helfer das Gerät neu startet bzw. die Batterie herausnimmt und wieder einsetzt, um ein Zurücksetzen des Gerätes zu erreichen."
    ],
    "Antworten": [
      "wird die HLW unverzüglich ohne den AED fortgeführt.",
      "führt ein Helfer die Basismaßnahmen weiter, während der Zweite Helfer das Gerät neu startet bzw. die Batterie herausnimmt und wieder einsetzt, um ein Zurücksetzen des Gerätes zu erreichen."
    ]
  },
  {
    "Nummer": 38,
    "Frage": "Bei einer Fraktur des Oberarms können ... ml Blut durch die zur Verfügung stehenden Körperhöhlen oder Weichteile verloren gehen",
    "Optionen": [
      "400",
      "1000",
      "5000",
      "2000",
      "800"
    ],
    "Antworten": [
      "800"
    ]
  },
  {
    "Nummer": 19,
    "Frage": "Bei Bewusstlosigkeit besteht die Gefahr einer Aspiration. Warum?",
    "Optionen": [
      "Weil die Stimmritze geschlossen ist.",
      "Weil der Bewusstlose nur unzureichend atmet.",
      "Weil der Bewusstlose keine Hustenreflexe hat."
    ],
    "Antworten": [
      "Weil der Bewusstlose keine Hustenreflexe hat."
    ]
  },
  {
    "Nummer": 23,
    "Frage": "Welcher Helfer gibt beim Überheben eines Verletzten auf die Trage (Aufheben von der Seite und aus dem Grätschstand) die Kommandos?",
    "Optionen": [
      "Der Helfer an den Beinen des Verletzten",
      "Der Helfer in der Mitte",
      "Der Helfer am Kopf des Verletzten",
      "Der Gruppen- oder Truppführer. Ansonsten nach Absprache"
    ],
    "Antworten": [
      "Der Helfer am Kopf des Verletzten"
    ]
  },
  {
    "Nummer": 18,
    "Frage": "Bei der palpatorischen Blutdruckmessung wird ... festgestellt.",
    "Optionen": [
      "der diastolische Blutdruck",
      "der mittlere Blutdruck",
      "der kapilläre Blutdruck",
      "der systolische Blutdruck"
    ],
    "Antworten": [
      "der systolische Blutdruck"
    ]
  },
  {
    "Nummer": 64,
    "Frage": "Der Guedeltubus",
    "Optionen": [
      "wird korrekt zwischen Mundwinkel und Ohrläppchen abgemessen.",
      "darf vom Sanitätshelfer nicht eigenständig eingesetzt werden.",
      "kann keinesfalls den Kehlkopfdeckel nach unten drücken.",
      "wird vom Sanitätshelfer auch als Führung für den Absaugkatheter verwendet.",
      "muss steril verpackt sein."
    ],
    "Antworten": [
      "wird korrekt zwischen Mundwinkel und Ohrläppchen abgemessen."
    ]
  },
  {
    "Nummer": 69,
    "Frage": "Welche Zuordnung von thermischen Schäden und Erkennungszeichen ist typisch?",
    "Optionen": [
      "Verbrühung: stärkste Schmerzen, Verkohlung der Hautstellen",
      "Sonnenstich: schneller Puls, Körpertemperatur >40°C, heiße trockene Haut",
      "Hitzeerschöpfung: auffallende Blässe, normale Körpertemperatur, kalter Schweiß mit Frösteln.",
      "Hitzschlag: langsamer Puls, hochroter Kopf, Nackenschmerzen."
    ],
    "Antworten": [
      "Hitzeerschöpfung: auffallende Blässe, normale Körpertemperatur, kalter Schweiß mit Frösteln.",
      "Hitzschlag: langsamer Puls, hochroter Kopf, Nackenschmerzen."
    ]
  },
  {
    "Nummer": 55,
    "Frage": "Mit welcher Frequenz muss die Herzdruckmassage bei der HLW des Erwachsenen ausgeführt werden?",
    "Optionen": [
      "ca. 60 - 80 / min",
      "ca. 100 - 120 / min",
      "ca. 120 - 140 / min",
      "ca. 80 - 100 / min",
      "ca. 140 - 160 / min"
    ],
    "Antworten": [
      "ca. 100 - 120 / min"
    ]
  },
  {
    "Nummer": 71,
    "Frage": "Welche Zeichen sprechen für eine Unterzuckerung?",
    "Optionen": [
      "kalter Schweiß, Zittern, Krämpfe",
      "Atem riecht wie faules Obst (Aceton)",
      "Kälteempfinden an den Händen und Füßen",
      "heiße, trockene Haut und auffallend tiefe Atemzüge"
    ],
    "Antworten": [
      "kalter Schweiß, Zittern, Krämpfe",
      "Kälteempfinden an den Händen und Füßen"
    ]
  },
  {
    "Nummer": 39,
    "Frage": "Bei einer Fraktur des Unterschenkels können ... ml Blut durch die zur Verfügung stehenden Körperhöhlen oder Weichteile verloren gehen",
    "Optionen": [
      "400",
      "5000",
      "2000",
      "1000",
      "800"
    ],
    "Antworten": [
      "1000"
    ]
  },
  {
    "Nummer": 25,
    "Frage": "Zum Beispiel bei Sportveranstaltungen unter Hitzebelastung kann es zum Kreislaufversagen infolge von starken Wasser- und Salzverlusten kommen. Wie nennt man dieses?",
    "Optionen": [
      "Hitzschlag",
      "Hitzeerschöpfung",
      "Schock",
      "Sonnenstich",
      "Verbrennung"
    ],
    "Antworten": [
      "Hitzeerschöpfung"
    ]
  },
  {
    "Nummer": 43,
    "Frage": "Wie tief soll der Brustkorb bei der Herzdruckmassage beim Erwachsenen eingedrückt werden?",
    "Optionen": [
      "So tief, dass einzelne Rippen brechen. Es geht dann auch leichter.",
      "Höchstens 4 Zentimeter",
      "ca. 2 Zentimeter",
      "So tief es geht, um eine möglichst gute Pumpfunktion zu erreichen.",
      "5 bis 6 Zentimeter"
    ],
    "Antworten": [
      "5 bis 6 Zentimeter"
    ]
  },
  {
    "Nummer": 235,
    "Frage": "Bei Gelenkverletzungen...",
    "Optionen": [
      "schließt eine unveränderte Beweglichkeit weitere Spätfolgen aus.",
      "ist eine Behandlung durch einen Arzt meist unnötig.",
      "soll der Sanitätshelfer/Sanitäter bei nur geringer Fehlstellung einen Wiedereinrenkungsversuch vornehmen.",
      "soll der Sanitätshelfer/Sanitäter das Gelenk ruhigstellen und kühlen."
    ],
    "Antworten": [
      "soll der Sanitätshelfer/Sanitäter das Gelenk ruhigstellen und kühlen."
    ]
  },
  {
    "Nummer": 215,
    "Frage": "Welche der Antwortmöglichkeiten trägt nicht in erster Linie zum Eigenschutz der Einsatzkräfte bei?",
    "Optionen": [
      "Gefahren für sich und andere erkennen",
      "Retten aus akuter Gefahr",
      "Ruhe bewahren",
      "Überblick verschaffen",
      "Zurückdrängen von Schaulustigen durch Erteilen von Platzverweisen."
    ],
    "Antworten": [
      "Retten aus akuter Gefahr"
    ]
  },
  {
    "Nummer": 230,
    "Frage": "Das akute Koronarsyndrom...",
    "Optionen": [
      "ist eine sehr seltene Erkrankung.",
      "benötigt in der Regel keine Krankenhausbehandlung.",
      "sollte durch den Sanitätshelfer der DLRG nicht mit Sauerstoff behandelt werden, da die bereits vorgeschädigten Herzmuskelzellen weiter geschädigt werden.",
      "entsteht in der Regel durch eine plötzliche Unterbrechung oder Verringerung der Blutzufuhr zu einem Teil des Herzmuskels.",
      "kann nur einmal bei einem Patienten auftreten. Nach der Behandlung ist der Patient vor einem Wiederauftreten geschützt."
    ],
    "Antworten": [
      "entsteht in der Regel durch eine plötzliche Unterbrechung oder Verringerung der Blutzufuhr zu einem Teil des Herzmuskels."
    ]
  },
  {
    "Nummer": 73,
    "Frage": "Welche Aussage zu Herz-Kreislauf-Erkrankungen trifft zu?",
    "Optionen": [
      "Bei einem Angina pectoris-Anfall kommt es zu einer Unterbrechung der Blutzufuhr zum Herzen, beim Herzinfarkt jedoch zu einer Minderversorgung.",
      "Ein Angina pectoris-Anfall ist immer gefährlicher als ein Herzinfarkt und bedarf eine Herz-Lungen-Wiederbelebung.",
      "Bluthochdruck ist ein Risikofaktor für Herz-Kreislauferkrankungen.",
      "Typisches Zeichen eines Herzinfarktes ist die Schmerzausstrahlung in das linke Bein."
    ],
    "Antworten": [
      "Bei einem Angina pectoris-Anfall kommt es zu einer Unterbrechung der Blutzufuhr zum Herzen, beim Herzinfarkt jedoch zu einer Minderversorgung."
    ]
  },
  {
    "Nummer": 228,
    "Frage": "Dieses Symbol weist hin auf... (Symbol: Herz mit Blitz)",
    "Optionen": [
      "eine Rettungswache",
      "ein Krankenhaus",
      "eine Erste-Hilfe-Station",
      "eine Notrufsäule",
      "einen Automatisierten Externen Defibrillator"
    ],
    "Antworten": [
      "einen Automatisierten Externen Defibrillator"
    ]
  },
  {
    "Nummer": 45,
    "Frage": "Mit dem Rettungstuch können zwei Helfer einen Verletzten...",
    "Optionen": [
      "achsengerecht lagern und abtransportieren, sofern vorher die Halswirbelsäule immobilisiert wurde",
      "aus einer Gefahrenzone schleifen oder sitzend tragen",
      "nicht transportieren",
      "liegend tragen"
    ],
    "Antworten": [
      "aus einer Gefahrenzone schleifen oder sitzend tragen"
    ]
  },
  {
    "Nummer": 84,
    "Frage": "Welche Aussage zur Blutdruckmessung ist korrekt?",
    "Optionen": [
      "Der diastolische Wert ist immer höher als der systolische Wert.",
      "Die Größe der Blutdruckmanschette hat nur einen minimalen Einfluss auf das Messergebnis.",
      "Bei der palpatorischen Messung erhält man zwei Werte (Systole und Diastole)",
      "Vor Anlegen an den Oberarm muss die Blutdruckmanschette luftleer sein."
    ],
    "Antworten": [
      "Vor Anlegen an den Oberarm muss die Blutdruckmanschette luftleer sein."
    ]
  },
  {
    "Nummer": 47,
    "Frage": "Der äußere Gasaustausch findet statt zwischen...",
    "Optionen": [
      "den Bronchiolen und den Kapillaren der Lunge",
      "der Pleura und den Kapillaren der Lunge",
      "den Alveolen und den Kapillaren der Lunge"
    ],
    "Antworten": [
      "den Alveolen und den Kapillaren der Lunge"
    ]
  },
  {
    "Nummer": 216,
    "Frage": "Nenne die \"3 W\", die zum Notruf gehören.",
    "Optionen": null,
    "Antworten": [
      "Wo?",
      "Was?",
      "Warten auf Rückfragen"
    ]
  },
  {
    "Nummer": 42,
    "Frage": "Die Herztätigkeit bei Säuglingen kontrolliert man durch Tasten ...",
    "Optionen": [
      "an der Halsschlagader",
      "am Oberarm",
      "am Handgelenk"
    ],
    "Antworten": [
      "am Oberarm"
    ]
  },
  {
    "Nummer": 67,
    "Frage": "Welche Aussage zum Schlaganfall trifft zu?",
    "Optionen": [
      "Zeichen eines Schlaganfalls können nach Stunden oder Tagen wieder verschwinden.",
      "Bei erhaltenem Bewusstsein besteht bei einem Patienten mit einem Schlaganfall keinesfalls das Risiko einer Aspiration.",
      "Es gibt keine typischen Erkennungszeichen für einen Schlaganfall.",
      "Ein Schlaganfall tritt nur bei Patienten über 45 Jahren auf."
    ],
    "Antworten": [
      "Zeichen eines Schlaganfalls können nach Stunden oder Tagen wieder verschwinden."
    ]
  },
  {
    "Nummer": 149,
    "Frage": "Welche Beschreibung trifft auf die Fritsch'sche Lagerung zu?",
    "Optionen": [
      "Rückenlage, Beine gestreckt und überkreuzt, sterile Vorlage vor der Vagina.",
      "Rückenlage, Füße aufgestellt, Gesäß leicht angehoben.",
      "es gibt keine Fritsch'sche Lagerung.",
      "Patientin liegt auf der Seite und hat die Knie zum Bauch gezogen.",
      "Patientin liegt auf der linken Seite."
    ],
    "Antworten": [
      "Rückenlage, Beine gestreckt und überkreuzt, sterile Vorlage vor der Vagina."
    ]
  },
  {
    "Nummer": 78,
    "Frage": "Welche Bedeutung hat bei der Verbrennung die Beurteilung der Schwere?",
    "Optionen": [
      "Große Bedeutung. Verbrennungsgrad, als auch beteiligte Körperoberfläche bestimmen die Schwere.",
      "Keine Bedeutung, denn akute Lebensgefahr besteht immer.",
      "Geringe Bedeutung. Als Abschätzung ist der Verbrennungsgrad ausreichend.",
      "Geringe Bedeutung. Als Abschätzung ist die beteiligte Körperoberfläche ausreichend."
    ],
    "Antworten": [
      "Große Bedeutung. Verbrennungsgrad, als auch beteiligte Körperoberfläche bestimmen die Schwere."
    ]
  },
  {
    "Nummer": 5,
    "Frage": "Welche der folgenden Situationen fällt nicht unmittelbar unter den Begriff \"medizinischer Notfall\"?",
    "Optionen": [
      "neu aufgetretene Halbseitenlähmung",
      "Vergiftung mit Tabletten",
      "Sturz aus 3,5m Höhe auf Betonboden",
      "Allergische Reaktion auf Erdnüsse",
      "Brechdurchfall"
    ],
    "Antworten": [
      "Brechdurchfall"
    ]
  }
];

export default function App() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [shuffledQuestions, setShuffledQuestions] = useState(questionsData);
  const [direction, setDirection] = useState(0); // For slide animation direction

  // Function to shuffle array
  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  const handleShuffle = () => {
    setShuffledQuestions(shuffleArray(questionsData));
    setCurrentIndex(0);
    setIsFlipped(false);
  };

  const handleNext = () => {
    if (currentIndex < shuffledQuestions.length - 1) {
      setIsFlipped(false);
      setDirection(1);
      setTimeout(() => setCurrentIndex(prev => prev + 1), 200);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setIsFlipped(false);
      setDirection(-1);
      setTimeout(() => setCurrentIndex(prev => prev - 1), 200);
    }
  };

  const currentCard = shuffledQuestions[currentIndex];

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col items-center py-8 px-4 font-sans text-slate-800">
      
      {/* Header */}
      <header className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-2">Sanitätshelfer (San A)</h1>
        <h2 className="text-xl text-slate-600">Prüfungstraining</h2>
      </header>

      {/* Controls & Progress */}
      <div className="w-full max-w-2xl flex justify-between items-center mb-6">
        <div className="text-sm font-semibold text-slate-500">
          Frage {currentIndex + 1} von {shuffledQuestions.length}
        </div>
        <button 
          onClick={handleShuffle}
          className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-sm hover:bg-slate-50 hover:text-blue-600 transition-colors text-sm font-medium border border-slate-200"
        >
          <RefreshCw size={16} />
          Mischen
        </button>
      </div>

      {/* Progress Bar */}
      <div className="w-full max-w-2xl h-2 bg-slate-200 rounded-full mb-8 overflow-hidden">
        <div 
          className="h-full bg-red-500 transition-all duration-300 ease-out"
          style={{ width: `${((currentIndex + 1) / shuffledQuestions.length) * 100}%` }}
        />
      </div>

      {/* Card Container */}
      <div className="relative w-full max-w-2xl aspect-[4/3] perspective-1000 group cursor-pointer" onClick={() => setIsFlipped(!isFlipped)}>
        <div className={`relative w-full h-full transition-all duration-500 transform-style-3d ${isFlipped ? 'rotate-y-180' : ''}`}>
          
          {/* Front of Card (Question) */}
          <div className="absolute inset-0 w-full h-full bg-white rounded-2xl shadow-xl border-l-8 border-red-500 p-8 backface-hidden flex flex-col overflow-auto">
            <div className="flex justify-between items-start mb-4">
              <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide">
                Frage #{currentCard.Nummer}
              </span>
              <HelpCircle className="text-slate-300" size={24} />
            </div>
            
            <div className="flex-grow flex flex-col justify-center">
              <h3 className="text-xl md:text-2xl font-bold text-slate-800 mb-6 leading-tight">
                {currentCard.Frage}
              </h3>
              
              {currentCard.Optionen && (
                <div className="space-y-3">
                  {currentCard.Optionen.map((opt, idx) => (
                    <div key={idx} className="flex items-start gap-3 text-slate-600">
                      <div className="mt-1 min-w-[16px] h-4 w-4 rounded-full border-2 border-slate-300" />
                      <span className="text-sm md:text-base">{opt}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <div className="mt-4 text-center text-xs text-slate-400 font-medium uppercase tracking-widest">
              Zum Umdrehen klicken
            </div>
          </div>

          {/* Back of Card (Answer) */}
          <div className="absolute inset-0 w-full h-full bg-slate-800 rounded-2xl shadow-xl border-r-8 border-green-500 p-8 rotate-y-180 backface-hidden flex flex-col">
             <div className="flex justify-between items-start mb-4">
              <span className="bg-green-900 text-green-300 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide">
                Lösung
              </span>
              <CheckCircle className="text-green-500" size={24} />
            </div>

            <div className="flex-grow flex flex-col justify-center items-center text-center">
              <div className="space-y-4 w-full">
                {currentCard.Antworten.map((antwort, idx) => (
                  <div key={idx} className="bg-green-500/10 border border-green-500/30 p-4 rounded-xl">
                    <p className="text-lg md:text-xl font-medium text-green-100">
                      {antwort}
                    </p>
                  </div>
                ))}
              </div>
            </div>

             <div className="mt-4 text-center text-xs text-slate-500 font-medium uppercase tracking-widest">
              Zum Umdrehen klicken
            </div>
          </div>

        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex gap-4 mt-8 w-full max-w-2xl justify-center">
        <button 
          onClick={(e) => { e.stopPropagation(); handlePrev(); }}
          disabled={currentIndex === 0}
          className={`flex items-center gap-2 px-6 py-3 rounded-xl font-bold transition-all ${
            currentIndex === 0 
              ? 'bg-slate-200 text-slate-400 cursor-not-allowed' 
              : 'bg-white text-slate-700 shadow-md hover:shadow-lg hover:bg-white hover:text-red-600'
          }`}
        >
          <ChevronLeft size={20} />
          Zurück
        </button>

        <button 
          onClick={(e) => { e.stopPropagation(); setIsFlipped(!isFlipped); }}
          className="md:hidden flex items-center justify-center bg-slate-200 text-slate-600 h-12 w-12 rounded-full"
        >
          <RotateCw size={20} />
        </button>

        <button 
          onClick={(e) => { e.stopPropagation(); handleNext(); }}
          disabled={currentIndex === shuffledQuestions.length - 1}
          className={`flex items-center gap-2 px-6 py-3 rounded-xl font-bold transition-all ${
            currentIndex === shuffledQuestions.length - 1
              ? 'bg-slate-200 text-slate-400 cursor-not-allowed' 
              : 'bg-red-600 text-white shadow-md shadow-red-200 hover:shadow-lg hover:bg-red-700'
          }`}
        >
          Weiter
          <ChevronRight size={20} />
        </button>
      </div>

      <style jsx global>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .transform-style-3d {
          transform-style: preserve-3d;
        }
        .backface-hidden {
          backface-visibility: hidden;
        }
        .rotate-y-180 {
          transform: rotateY(180deg);
        }
      `}</style>
    </div>
  );
}

const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(<App />);
